import cls from 'classnames'
import React from 'react'

import * as SC from './styles'

interface ListItemProps {
    children?: React.ReactNode

    icon?: string
    title: React.ReactNode
    suffix?: React.ReactNode
    className?: string
    style?: React.CSSProperties
    disabled?: boolean
    onClick?: () => void
}

const ListItem: React.FC<ListItemProps> = ({ icon, title, suffix, style, className, disabled, onClick }) => {
    return (
        <SC.ItemWrapper className={cls({ disabled: !!disabled }, className)} style={style} onClick={disabled ? undefined : onClick}>
            <SC.InfoWrapper>
                {icon && <SC.InfoIcon type={icon} />}
                <SC.InfoText>{title}</SC.InfoText>
            </SC.InfoWrapper>
            <SC.ActionWrapper>{suffix}</SC.ActionWrapper>
        </SC.ItemWrapper>
    )
}

export default ListItem
